<template>
    <transition name="fade">
        <div class="hi-modal-wrap">
            <div class="modal hi-modal" tabindex="-1">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header border-0" v-if="showHeader">
                            <h5 class="modal-title">
                                {{ headerTitle }}
                            </h5>
                            <button type="button" class="close" @click="closeModal()">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <slot name="body" />
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-confirm" @click="submit">
                                {{ okTitle }}
                            </button>
                            <button class="btn btn-cancel" @click="closeModal" v-if="showCancel">
                                {{ cancelTitle }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-backdrop" v-if="show"></div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: "HiModal",
        data() {
            return {
                show: false,
            };
        },
        props: {
            okTitle: {
                type: String,
                default: "Ok",
            },
            cancelTitle: {
                type: String,
                default: "Cancel",
            },
            showCancel: {
                type: Boolean,
                default: true,
            },
            showHeader: {
                type: Boolean,
                default: true,
            },
            headerTitle: {
                type: String,
            },
        },
        methods: {
            openModal() {
                this.show = true;
                document.querySelector(".modal").classList.add("show");
                document.querySelector("body").classList.add("modal-open");
            },
            closeModal() {
                this.show = false;
                document.querySelector(".modal").classList.remove("show");
                document.querySelector("body").classList.remove("modal-open");
            },
            submit() {
                this.$emit("Ok", "from children");
            },
            none() {
                console.log("none fired");
            },
        },
    };
</script>
<style lang="css">
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>